
import { SearchableItem } from "./types/search"

export class StatusNotAcceptableError extends Error {}

export async function get<T>(url: string): Promise<T> {
    const resp = await fetch(url, {
        method: 'get',
        headers: { 'accept': 'application/json' },
        credentials: 'include',
    })
    if (resp.status !== 200 && resp.status !== 304) {
        throw new StatusNotAcceptableError()
    }
    
    return await resp.json()
}

export async function post<D, T>(url: string, data: D): Promise<T> {
    const body = data instanceof URLSearchParams ? data : JSON.stringify(data)
    const headers = data instanceof URLSearchParams ? [] : [["content-type", "application/json"]]
    const resp = await fetch(url, {
        method: 'post',
        body,
        headers,
        credentials: 'include',
    })
    
    return await resp.json()
}

export function groupBy<T> (arr: SearchableItem<T>[], key: string): Record<string, SearchableItem<T>[]> {
    return arr.reduce((o: Record<string, SearchableItem<T>[]>, v) => {
        const value = v?.indexMap?.get(key)
        if (value) {
            o[value] = (o[value] || []).concat([v])
        }
        return o
    }, {})
}

export const ucfirst = (s: string) => `${s[0].toUpperCase()}${s.slice(1)}`
export const searchable = (s: string) => s.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')
